/**
 * @description вычисляет уровень зума в зависимости от типа гео (улица, дом и тд)
 *
 * @param {string} type тип гео объекта (дом, улица и тд), адрес которого введен в поиске
 * @param {boolean} isLocationRequired нужно ли уточнить локацию, если адрес недостаточно точный
 *
 * @returns {number} зум, совместимый с Яндекс картами
 */
export function computeMarkerZoomByGeoType(type = 'location', isLocationRequired = false) {
  // Зумим до уровня улицы, если не смогли определить локацию, но хотим
  // чтобы пользователю было удобнее переместить пин
  if (isLocationRequired && type === 'location') {
    return 15;
  }

  switch (type) {
    case 'house':
      return 17;
    case 'street':
      return 15;
    case 'location':
    default:
      return 13;
  }
}
